var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemLineElement_1;
import { CustomElement, P, Watch, PropertyConverters } from '@pacem/pacem-core';
import { LineGeometry } from '../geometry';
import { Pacem3DPrimitiveElement } from './primitive';
import { TAG_MIDDLE_NAME } from '../constants';
//namespace Pacem.Components.Drawing3D {
const DEFAULT_LINE = [{ x: 0, y: 0, z: 0 }, { x: 0, y: 1, z: 0 }];
let PacemLineElement = PacemLineElement_1 = class PacemLineElement extends Pacem3DPrimitiveElement {
    static createLineGeometry(positions) {
        return new LineGeometry(positions || DEFAULT_LINE);
    }
    createDefaultGeometry() {
        return PacemLineElement_1.createLineGeometry();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'positions':
                this.geometry = PacemLineElement_1.createLineGeometry(val);
                break;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemLineElement.prototype, "positions", void 0);
PacemLineElement = PacemLineElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-primitive-line' })
], PacemLineElement);
export { PacemLineElement };
